// src/index.default.ts
var cookies = void 0;
var headers = void 0;
var isReactServer = false;
export {
  cookies,
  headers,
  isReactServer
};
//# sourceMappingURL=index.default.js.map